// extracted by mini-css-extract-plugin
module.exports = {"card":"EditModal_card__lh4CE","cardHeader":"EditModal_cardHeader__3TtKE","input":"EditModal_input__1MxEj"};